module.exports = __webpack_public_path__ + "img/handwithphone.01fd6a08.png";